import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js";

// Connects to data-controller="select-text-input"
export default class extends Controller {
  static values = {
    addChoices: { type: Boolean, default: false },
    removeItemButton: { type: Boolean, default: false },
  }
  connect() {
    this.choicesInstance = new Choices(this.element,{
      addChoices: this.addChoicesValue,
      removeItemButton: this.removeItemButtonValue,
    });
  }
}
